import { forwardRef } from 'react';
import Glider from 'react-glider';
import * as st from './styles.module.scss';
import 'glider-js/glider.min.css';
import type { ExtendedGlide } from '@shared/types/products';

type Props = {
  images: string[] | undefined;
};

export const SmallCarousel = forwardRef<ExtendedGlide, Props>(({ images }, ref) => {
  return (
    <Glider
      hasArrows
      rewind
      slidesToShow={1}
      slidesToScroll={1}
      arrows={{
        prev: '#buttonLeft',
        next: '#buttonRight',
      }}
      className={st.glider}
      itemWidth={256}
      ref={ref}
      responsive={[
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            itemWidth: 350,
          },
        },
      ]}
    >
      {images &&
        images.map((img) => (
          <div className={st.wrapper} key={img}>
            <img className={st.image} src={img} alt="" />
          </div>
        ))}
    </Glider>
  );
});
